import React from "react";
import { ShoppingCart, GraduationCap, Waves, Trees, Utensils, MapPin, Car } from "lucide-react";

export const NEARBY_CATEGORIES = ["Grocery", "Schools", "Beaches", "Parks", "Restaurants", "Other"];
const ICONS = { Grocery: ShoppingCart, Schools: GraduationCap, Beaches: Waves, Parks: Trees, Restaurants: Utensils, Other: MapPin };

export function NearbySection({ nearby, testId }) {
  const items = nearby?.items || [];
  const drives = nearby?.drives || [];
  if (!items.length && !drives.length) return null;
  const groups = NEARBY_CATEGORIES.map((c) => [c, items.filter((i) => (NEARBY_CATEGORIES.includes(i.category) ? i.category : "Other") === c)]).filter(([, l]) => l.length);
  return (
    <div className="mt-4 p-4 rounded-xl border border-border bg-card" data-testid={testId}>
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3 flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> What's nearby</p>
      {drives.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3">
          {drives.map((d, i) => (
            <span key={i} className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-primary/10 text-foreground" data-testid={`${testId}-drive-${i}`}>
              <Car className="h-3 w-3 text-primary" /> {d.label}{d.minutes ? ` · ~${d.minutes} min` : ""}{d.miles ? ` (${d.miles} mi)` : ""}
            </span>
          ))}
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-3">
        {groups.map(([cat, list]) => {
          const Icon = ICONS[cat];
          return (
            <div key={cat}>
              <p className="text-xs font-semibold flex items-center gap-1.5 mb-1"><Icon className="h-3.5 w-3.5 text-forest" /> {cat}</p>
              <ul className="space-y-0.5">{list.map((it, i) => <li key={i} className="text-xs text-foreground/80">{it.name}{it.detail ? <span className="text-muted-foreground"> · {it.detail}</span> : null}</li>)}</ul>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-muted-foreground mt-3">Drive times are approximate and change with traffic. Distances are straight-line. We don't rate schools or neighborhoods, so visit and review them yourself.</p>
    </div>
  );
}
